import * as pathToRegexp from 'path-to-regexp'

// path-to-regexp only accepts '?' as an optional modifier right after a :param
// or a (regex) group; anywhere else it starts a query string, which pathname
// matching and interpolation can't consume. Route patterns that carry a query
// template (e.g. '/operations/cases?case=:id?') must be reduced to their
// pathname part before hitting path-to-regexp.
export const stripQueryFromPattern = (pattern: string): string => {
  for (let i = 0; i < pattern.length; i++) {
    if (pattern[i] !== '?') continue
    const isModifier = /(:[A-Za-z0-9_]+|\)|\})$/.test(pattern.slice(0, i))
    if (!isModifier) return pattern.slice(0, i)
  }
  return pattern
}

// v3 typings omit the decode option even though the runtime supports it
type MatchOptions = pathToRegexp.ParseOptions & {
  decode?: (value: string, token: pathToRegexp.Key) => string
}

const matchOptions: MatchOptions = { decode: decodeURIComponent }

export const createPatternMatcher = (pattern: string) =>
  pathToRegexp.match(stripQueryFromPattern(pattern), matchOptions)
